import { PlateContent } from '@udecode/plate/react';
import styled, { css } from 'styled-components';
import { Button } from '../Button';
import { ChevronDownIcon } from '../Icons';
import { ICON_CLASS, tokens as iconTokens } from '../Icons/tokens';
import { Input } from '../Input';
import { StyledInputContainer } from '../Input/styled';
import { Stack } from '../Layout';
import { theme, UI_TYPOGRAPHY_ROOT_CLASS } from '../theme';
export const StyledMarkdownContainer = styled.div`
  width: 100%;
  height: 100%;
`;
export const markdownStyles = css`
  table {
    width: 100%;
    table-layout: fixed;

    td,
    th {
      width: auto;
      word-wrap: break-word;
      overflow-wrap: break-word;
      min-width: 60px;

      & > p {
        margin: 0;
        display: inline;
      }
      padding: ${theme.spaces.x8} ${theme.spaces.x12};
    }
  }

  p[class*='slate-indent']:has(+ p[class*='slate-indent']) {
    margin: 0;
  }

  span {
    color: ${theme.colors.gray700};
  }

  ul,
  ol {
    li {
      margin: 0;
      margin-top: ${theme.spaces.x4};
    }
  }

  // if all td inside tr has highlight element then we don't need to show highlight

  img {
    width: 100%;
    max-width: 1000px;
  }

  a span {
    color: ${theme.colors.brand500};
  }

  a {
    text-decoration: underline;
    text-underline-offset: ${theme.spaces.x4};
    text-decoration-style: dotted;
  }
`;
export const StyledMarkdownEditor = styled(Stack)`
  border-radius: ${theme.radius.x8};
  border: 1px solid ${theme.colors.gray200};
  height: 100%;

  .${UI_TYPOGRAPHY_ROOT_CLASS} {
    ${markdownStyles}
  }
`;
export const StyledPlateContent = styled(PlateContent)`
  border: 0;
  outline: none;
  padding: ${theme.spaces.x24};
  overflow: auto;
  flex-grow: 1;
`;
export const StyledButton = styled(Button)`
  padding: ${theme.spaces.x6};
  width: ${({ width })=>width || theme.sizes.x28};
  height: ${theme.sizes.x28};
  color: ${theme.colors.gray600};
  transition: none;
  box-shadow: none;
  border-radius: ${theme.radius.x6};

  && {
    &:hover,
    &:focus,
    &:active,
    &[data-active='true'] {
      box-shadow: none;
      color: ${theme.colors.gray700};
    }
  }

  &[data-active='true'] {
    box-shadow: none;
    background-color: ${theme.colors.gray100};
  }
`;
export const StyledDropdownHandle = styled(Button)`
  padding: ${theme.spaces.x6};
  height: ${theme.sizes.x32};
  text-wrap: nowrap;
  word-break: keep-all;

  color: ${theme.colors.gray600};

  && {
    &:hover,
    &:focus,
    &:active {
      border: none;
      color: ${theme.colors.gray700};
    }
  }
`;
export const StyledFixedToolbar = styled(Stack)`
  background: ${theme.colors.gray25};
  border-bottom: 1px solid ${theme.colors.gray200};
  border-top-left-radius: ${theme.radius.x8};
  border-top-right-radius: ${theme.radius.x8};
  padding: ${theme.spaces.x2} ${theme.spaces.x10};
  height: ${theme.sizes.x44};
  flex-shrink: 0;
`;
export const StyledFloatingToolbar = styled(Stack)`
  background: ${theme.colors.white};
  border-radius: ${theme.radius.x8};
  border: 1px solid ${theme.colors.gray200};
  padding: 0 ${theme.spaces.x8};
  height: ${theme.sizes.x40};
  box-shadow: ${theme.shadows.md};
`;
export const StyledLinkInput = styled(Input)`
  width: 400px;
  height: 100%;
  max-width: 60vw;

  ${StyledInputContainer} {
    border: none;
    box-shadow: none;
    outline: none;
    height: 100%;
    padding: 0 ${theme.spaces.x6};
  }
`;
export const StyledToolbarArrowIcon = styled(ChevronDownIcon)`
  &&& {
    font-size: ${iconTokens.Icon.xs.size};
  }
`;
export const StyledIconWithLabel = styled(Stack)`
  .${ICON_CLASS} {
    color: ${({ disabled })=>disabled ? theme.colors.gray300 : theme.colors.gray600};
    font-size: ${theme.sizes.x18};
  }
`;
